import React from 'react';
import { format } from 'date-fns';
import { StormReport } from '../../types/storm';

interface StormReportDetailsProps {
  report: StormReport;
}

export function StormReportDetails({ report }: StormReportDetailsProps) {
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-2 gap-2">
        <span className="text-[var(--secondary-text)]">Location:</span>
        <span>{report.locationName}</span>
        
        <span className="text-[var(--secondary-text)]">Time:</span>
        <span>{format(new Date(report.report?.dateTimeISO || ''), 'PPpp')}</span>
        
        <span className="text-[var(--secondary-text)]">Type:</span>
        <span>{report.report?.type}</span>
        
        <span className="text-[var(--secondary-text)]">Category:</span>
        <span>{report.report?.cat}</span>
        
        {report.report?.cat === 'hail' && report.report?.detail?.hailIN && (
          <>
            <span className="text-[var(--secondary-text)]">Hail Size:</span>
            <span>{report.report.detail.hailIN} inches</span>
          </>
        )}
        
        <span className="text-[var(--secondary-text)]">Reporter:</span>
        <span>{report.report?.reporter || 'N/A'}</span>
      </div>
      
      {report.report?.detail?.text && (
        <div>
          <span className="text-[var(--secondary-text)] block">Details:</span>
          <p className="mt-1">{report.report.detail.text}</p>
        </div>
      )}
      
      {report.report?.comments && (
        <div>
          <span className="text-[var(--secondary-text)] block">Comments:</span>
          <p className="mt-1">{report.report.comments}</p>
        </div>
      )}
    </div>
  );
}